module.exports = __webpack_public_path__ + "img/menu.482e46ad.svg";